import {
  useSuspenseQuery,
  type UseSuspenseQueryOptions,
} from '@tanstack/react-query';
import type { GetValorantPlayerResponse } from 'generated/openapi';

import {
  getValorantPlayerKey,
  getValorantPlayerOptions,
  type ValorantPlayerKeyParams,
} from './getValorantPlayer.options';

export interface UseGetValorantPlayerProps<
  T = GetValorantPlayerResponse,
> extends ValorantPlayerKeyParams {
  options?: Omit<
    UseSuspenseQueryOptions<GetValorantPlayerResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

/**
 * Hook to fetch VALORANT player data by PUUID
 */
export function useGetValorantPlayer<T = GetValorantPlayerResponse>({
  options,
  ...params
}: UseGetValorantPlayerProps<T>) {
  return useSuspenseQuery({
    ...getValorantPlayerOptions<T>(params),
    ...options,
  });
}

useGetValorantPlayer.getQueryKey = getValorantPlayerKey;
